import type { FaireProductEntity } from "../../entity_types/product";

export const p_45seygkeux: FaireProductEntity = {
  token: "p_45seygkeux",
  type: "product",
  name: "Boots & Bows",
  brandToken: "b_h93v6v8mbm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d668432febf84fd7706b229b4c0c1673ebb277fe98cb01491b310c3861af48d5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/080b3684893a986e52643006805739bb8fedc5e8978548a26fe6c1632545cbe9.jpeg",
  ],
  priceDollars: 19.4,
  description:
    "Handcrafted polymer clay statement earrings. Handmade with love!\n\nAll studs are 100% hypoallergenic, stainless steel posts. Ball posts, hoops and dangles are stainless steel and coated with 18k gold. (nickel free!) Stud backs are secured with resin, which will mean they will last much longer and have higher durability!\n\nAll pairs are unique and should not be expected to be exactly the same! Remember, they're made by a human, not a machine! :)",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:22.420Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
